import type { ReactNode } from 'react';
import { FILTRE_GIRIS, FiltreAlani } from '../rapor-ekrani/RaporFiltreBari';
import { TUMU_ACIK, TUMU_KAPALI, type GrupAcikligi } from '../rapor-ekrani/kolon';
import { GRUPLAMA_ALANLARI, type GruplamaAlani } from './tipler';

/** S345: stok raporlarının ortak filtre alanları (ürün grubu, gruplama) ve çekmece parçaları. */

/** Filtre barındaki açılır seçim; giriş alanlarıyla aynı ölçü (`FILTRE_GIRIS`). */
function Secim({ etiket, deger, secenekler, onDegis }: {
  etiket: string;
  deger: string;
  secenekler: ReadonlyArray<readonly [string, string]>;
  onDegis: (v: string) => void;
}) {
  return (
    <FiltreAlani etiket={etiket}>
      <select className={`${FILTRE_GIRIS} max-w-[220px] max-md:max-w-full max-md:w-full`} value={deger} onChange={(e) => onDegis(e.target.value)}>
        {secenekler.map(([v, ad]) => <option key={v} value={v}>{ad}</option>)}
      </select>
    </FiltreAlani>
  );
}

export function UrunGrubuSecimi({ deger, gruplar, onDegis }: { deger: string; gruplar: readonly string[]; onDegis: (v: string) => void }) {
  return <Secim etiket="Ürün grubu" deger={deger} onDegis={onDegis} secenekler={[['', 'Tümü'], ...gruplar.map((g) => [g, g] as const)]} />;
}

const DUGME =
  'focus-ring h-8 max-md:h-11 px-3 rounded-md border border-border-strong bg-surface text-[13px] font-medium text-ink-700 hover:bg-ink-50';

/** Gruplama seçimi; gruplama açıkken yanında "Tümünü aç / Tümünü kapat". */
export function GruplamaAlanlari({ alan, dolu, onSec, onAciklik }: {
  /** Uygulanan gruplama; '' = yok. */
  alan: GruplamaAlani | '';
  /** Veride dolu olan alanlar: seçenekler yalnız bunlar. */
  dolu: readonly GruplamaAlani[];
  onSec: (alan: GruplamaAlani | '') => void;
  onAciklik: (a: GrupAcikligi) => void;
}) {
  const secenekler = GRUPLAMA_ALANLARI.filter((g) => dolu.includes(g.id)).map((g) => [g.id, g.etiket] as const);
  return (
    <>
      <Secim etiket="Gruplama" deger={alan} onDegis={(v) => onSec(v as GruplamaAlani | '')} secenekler={[['', 'Yok'], ...secenekler]} />
      {alan !== '' && (
        <FiltreAlani etiket="Gruplar" grup>
          <span className="inline-flex gap-1.5">
            <button type="button" className={DUGME} onClick={() => onAciklik(TUMU_ACIK)}>Tümünü aç</button>
            <button type="button" className={DUGME} onClick={() => onAciklik(TUMU_KAPALI)}>Tümünü kapat</button>
          </span>
        </FiltreAlani>
      )}
    </>
  );
}

/** Çekmecedeki özet kutusu (Cari Hesap çekmecesindeki kutuyla aynı ölçü). */
export function Kutu({ etiket, children }: { etiket: string; children: ReactNode }) {
  return (
    <div className="bg-surface border border-border rounded-lg px-3 py-2 min-w-[120px]">
      <span className="block text-[11px] uppercase tracking-[0.04em] text-ink-500">{etiket}</span>
      <b className="mono text-[15px] font-semibold text-ink-900 leading-snug">{children}</b>
    </div>
  );
}
